import { createNonPersistentStore } from 'lib/zustand';
import { UpdatedState } from 'utils/updatedState/UpdatedState';
import { useUpdatedState } from 'utils/updatedState/useHelperState';

export const isCtrlPressedOnEvent = (event: KeyboardEvent | MouseEvent) => event.metaKey || event.ctrlKey;

const useIsCtrlPressedStore = createNonPersistentStore(
  () => ({
    isCtrlPressed: false
  }),
  { isListeningScreenStore: false }
);

class IsCtrlPressedState extends UpdatedState<boolean> {
  constructor() {
    super();

    const listener = (event: KeyboardEvent | MouseEvent) => {
      const isCtrlPressed = isCtrlPressedOnEvent(event);
      const storeValue = useIsCtrlPressedStore.getState().isCtrlPressed;
      if (storeValue === isCtrlPressed) return;
      useIsCtrlPressedStore.setState({ isCtrlPressed });
    };

    window.addEventListener('keydown', listener, { passive: true });
    window.addEventListener('keyup', listener, { passive: true });
    window.addEventListener('mousemove', listener, { passive: true });
    this.onDestroy(() => {
      window.removeEventListener('keydown', listener);
      window.removeEventListener('keyup', listener);
      window.removeEventListener('mousemove', listener);
    });
  }

  get state() {
    return useIsCtrlPressedStore.getState().isCtrlPressed;
  }

  _subscribeWithoutCleanup(callback: (state: boolean, oldState: boolean) => void) {
    return useIsCtrlPressedStore.subscribe((state, oldState) => callback(state.isCtrlPressed, oldState.isCtrlPressed));
  }
}

let isCtrlPressedState: IsCtrlPressedState | undefined;
export const getIsCtrlPressedState = () => {
  if (!isCtrlPressedState) {
    throw new Error('isCtrlPressedState is not initialized');
  }
  return isCtrlPressedState;
};
export const useIsCtrlPressed = () => useUpdatedState(getIsCtrlPressedState());
export const initIsCtrlPressedState = () => {
  isCtrlPressedState = new IsCtrlPressedState();
};
